import { http } from '@/utils/axios'

/**
 * @msg: 获取练习/测验记录
 */
export function getElExamsLogsList(data) {
    return http({
        url: http.baseUrl('elExamsLogs/getPage'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 获取班级学习记录
 */
 export function getLearnRecord(data) {
    return http({
        url: http.baseUrl('elAlbum/getLearnRecord'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}